"use strict";var inherit = require("raptor-util/inherit");
var VNode = require("./VNode");

function VText(value, ownerComponent) {
  this.bV_(-1 /* no children */, ownerComponent);
  this.bW_ = value;
}

VText.prototype = {
  cn_: true,

  bX_: 3,

  bo_: function (host) {
    return (host.ownerDocument || host).createTextNode(this.bW_);
  },

  bP_: function () {
    return new VText(this.bW_);
  }
};

inherit(VText, VNode);

module.exports = VText;